module.exports = __webpack_public_path__ + "img/logorm.777c4723.svg";